<template>
  <div class="pt-[300px]">
      <LoadingState></LoadingState>
  </div>
</template>

<script setup>
  import LoadingState from "@/components/exercices/LoadingState.vue";
  import {useGeneralStore} from "@/stores/general.js";
  import {onMounted} from "vue";
  import {useRoute} from "vue-router";

  const generalStore = useGeneralStore()
  const route = useRoute()

  onMounted(async () => {
    const packageSlug = route.params['package_slug']
    const promoCode = route.params['promo_code']


    let data = await generalStore.subscribe(packageSlug, promoCode)
    if (data.link) {
      window.location.href = data.link
    }
  })

</script>

<style scoped>

</style>
